import mandatoryLoginEvaluateProduct from "./mandatoryLoginEvaluateProduct"
export default mandatoryLoginEvaluateProduct;
